import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const couchDb = defineConnector({
  identifier: "couchDb",
  name: "CouchDB",
  tagLine: "Document-oriented database",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.cloudant\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your CouchDB instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "couchdb.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the username and password for your CouchDB admin user. See the [API docs](https://docs.couchdb.org/en/stable/api/) for details.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/_session`,
  },
});
